import styles from "../UserFields.module.scss";
import { CompanyData, ValidCompanyDataErrors } from "../../../../types/user";
import { Input } from "../../../simples/Input";
import { TextWithHintIcon } from "../../../simples/TextWithHintIcon";

type Props = {
  data: CompanyData;
  setData: (field: keyof CompanyData, value: string) => void;
  errors: ValidCompanyDataErrors | undefined;
  isBeenChange?: boolean;
};

const RightPartSelfEmployedUserFields = ({
  data,
  setData,
  errors,
  isBeenChange = true,
}: Props) => (
  <div className={styles.topSiteContainer}>
    <TextWithHintIcon
      classes={{ root: styles.topTitle }}
      title="Фамилия"
    />
    <Input
      error={errors?.surname && errors.surname[0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "surname")}
      value={data.surname}
      placeholder="Введите фамилию"
      disabled={!isBeenChange}
    />

    <TextWithHintIcon
      classes={{ root: styles.title }}
      title="Имя"
    />
    <Input
      error={errors?.["first-name"] && errors["first-name"][0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "first-name")}
      value={data["first-name"]}
      placeholder="Введите имя"
      disabled={!isBeenChange}
    />

    <TextWithHintIcon
      classes={{ root: styles.title }}
      title="Отчество"
    />
    <Input
      error={errors?.patronymic && errors.patronymic[0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "patronymic")}
      value={data.patronymic}
      placeholder="Введите отчество"
      disabled={!isBeenChange}
    />

    <TextWithHintIcon classes={{ root: styles.title }} title="Серия паспорта" />
    <Input
      error={errors?.["passport-series"] && errors["passport-series"][0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "passport-series")}
      value={data["passport-series"]}
      mask="9999"
      placeholder="0000"
      disabled={!isBeenChange}
    />

    <TextWithHintIcon classes={{ root: styles.title }} title="Номер паспорта" />
    <Input
      error={errors?.["passport-number"] && errors["passport-number"][0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "passport-number")}
      value={data["passport-number"]}
      mask="999999"
      placeholder="000000"
      disabled={!isBeenChange}
    />

    <TextWithHintIcon
      classes={{ root: styles.title }}
      title="Дата выдачи паспорта"
    />
    <Input
      error={
        errors?.["passport-issue-date"] && errors["passport-issue-date"][0]
      }
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "passport-issue-date")}
      value={data["passport-issue-date"]}
      mask="9999-99-99"
      placeholder="ГГГГ-ММ-ДД"
      disabled={!isBeenChange}
    />
  </div>
);

export default RightPartSelfEmployedUserFields;
